/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppId } from "../../commons/types/AppId";
import { TargetEnvironment } from "../../commons/types/TargetEnvironment";
export const TransformationSearchBody = core.serialization.object({
    appId: AppId,
    matchKeys: core.serialization.list(core.serialization.string()),
    filterKeys: core.serialization.list(core.serialization.string()).optional(),
    page: core.serialization.number().optional(),
    overlap: core.serialization.number().optional(),
    targetEnvironment: TargetEnvironment.optional(),
});
